import FJPoolStore from '../store/FJPoolStore';
import { BlurShaderManagerBySizeSingleton } from '@fj/webgl-blur';

const FJBlurUtil = {
    /**
     * @desc 绘制模糊效果
     * @param {string} blurType 模糊类型
     * @param {HTMLCanvasElement} imageCanvas 图片canvas
     * @param {Object} options 配置
     * @param {number} options.blurRadius 模糊半径
     * @returns {Object | null} 模糊结果
     */
    drawBlur: (blurType, imageCanvas, { blurRadius }) => {
        /**
         * BlurShaderManagerBySizeSingleton 在 fixedSize 为 true 时会针对 canvas 的 size 进行优化
         * 相同比例的 canvas 会复用 webgl 上下文，所以这里需要先创建一个 canvas，然后根据 imageCanvas 的 size 来设置 blurCanvas 的 size
         * 使得传入得 canvas 比例永远 1:1，避免重复创建 webgl 上下文
         */
        const blurCanvas = FJPoolStore.getCanvas('2d');
        const avgValue = Math.floor((imageCanvas.width + imageCanvas.height) / 2);
        const blurSize = { width: avgValue, height: avgValue };
        blurCanvas.width = blurSize.width;
        blurCanvas.height = blurSize.height;
        blurCanvas.getContext('2d').drawImage(imageCanvas, 0, 0, blurSize.width, blurSize.height);

        const result = BlurShaderManagerBySizeSingleton.draw(blurType, blurCanvas, null, {
            blurRadius,
            size: blurSize,
            fixedSize: true,
        });

        FJPoolStore.releaseCanvas(blurCanvas);

        return result;
    },
};

export default FJBlurUtil;
